import { render, staticRenderFns } from "./AutoAssignRulesList.vue?vue&type=template&id=71df0e61&"
import script from "./AutoAssignRulesList.vue?vue&type=script&lang=js&"
export * from "./AutoAssignRulesList.vue?vue&type=script&lang=js&"
import style0 from "./AutoAssignRulesList.vue?vue&type=style&index=0&id=71df0e61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports